import { useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import { useUploadProgress } from '../../contexts/UploadProgressProvider.js';
// import StatusProcessamento from '../../components/StatusProcessamento/statusprocessamento.js';

import Logo from '../../assets/images/logo.webp'
import { FcBusinessman } from "react-icons/fc"

export default function Header() {
  const { usuario, perfilUsuario, processandoImportacao } = useContext(AuthContext);
  const { isProcessing, progress, statusMessage, statusState } = useUploadProgress();

  function formatarDataDescritiva(data) {
    const opcoes = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return data.toLocaleDateString('pt-BR', opcoes);
  }

  function descricaoPerfil(perfilUsuario) {
    if (perfilUsuario === 'GS') { return 'Gestor' }
    if (perfilUsuario === 'AD') { return 'Administrador' }
    if (perfilUsuario === 'US') { return 'Usuário' }
    if (perfilUsuario === 'VS') { return 'Visitante' }
  }

  // Exemplo de uso
  const dataAtual = new Date();
  const dataFormatada = formatarDataDescritiva(dataAtual);

  return (
    <header className='flex justify-between bg-gray-100 md:py-3 py-5 px-4 items-center'>
      <a href="http://www.analub.com.br">
        <img src={Logo} className='logo' alt="Analub - Purificação de Lubrificantes" /></a>

      <div className="widget-user rounded-md">
        <div className="user">
          <div className="foto">
            <FcBusinessman size={50} />
          </div>
          <div className="user-info sm:block hidden">
            <p>Bem-vindo(a) {usuario.nome}</p>
            <p></p>
            <p className='text-sm'>{dataFormatada}</p>
            <p></p>
            <p className='text-sm'>Perfil: {descricaoPerfil(perfilUsuario)}</p>
          </div>
        </div>
      </div>


      {/* Componente que mostra o progresso do Lambda */}
      {isProcessing && (
        <div style={{ width: '350px', backgroundColor: '#c7d1e0', padding: '10px 15px', borderRadius: '8px' }}>

          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '8px' }}>
            <span>{statusMessage}</span>
            <span style={{ fontWeight: 'bold' }}>{progress}%</span>
          </div>
          {/* Barra de Progresso */}
          <div style={{ width: '100%', backgroundColor: '#c7d1e0', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
            <div
              style={{
                height: '100%',
                width: `${progress}%`,
                backgroundColor: statusState === 'ERRO' ? '#e53e3e' : statusState === 'SUCESSO' ? '#38a169' : '#3182ce',
                transition: 'width 0.4s ease-in-out'
              }}
            />
          </div>
        </div>
      )}

    </header>
  )
}
